<div class="row">
    <div class="col-sm-12">
        <div class="card">
            <div class="card-body">

                <form [formGroup]="formSearch" (submit)="refresh()">
                    <div class="row"
                        *ngIf="currentUser.authorities.includes('ADMIN-DINAS') || currentUser.authorities.includes('SUDIN') || currentUser.authorities.includes('ADMIN')|| currentUser.authorities.includes('ADM_TA') || currentUser.authorities.includes('ADMIN-BD-DINAS') || currentUser.authorities.includes('ADMIN-SUDIN')">
                        <!-- <div class="form-group col-2">
                            <small class="form-text text-muted">Kode / Nama OPD</small>
                            <input type="text" class="form-control" id="kodeNamaOpd" name="kodeNamaOpd"
                                formControlName="kodeNamaOpd" placeholder="Kode / Nama OPD">
                        </div> -->

                        <div class="form-group col-2">
                            <small class="form-text text-muted">NSPN / Nama Sekolah</small>
                            <input type="text" class="form-control" id="kodeNama" name="kodeNama"
                                formControlName="kodeNama" placeholder="NSPN / Nama sekolah">
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <button type="submit" class="btn btn-secondary" style="margin-top: 21px;">
                                    <i class=" fa fa-search"></i> Cari
                                </button>
                            </div>
                        </div>
                        <div class="row" style="padding-left: 30px;">
                            <div class="col-12">
                                <button type="button" class="btn btn-primary" style="margin-top: 21px;"
                                    [routerLink]="['/', 'administrator', 'batas-pengajuan-belanja-bku', 'sunting-all']">
                                    <i class="fa fa-send"></i> Setting Semua Sekolah
                                </button>
                            </div>
                        </div>
                    </div>
                </form>

                <hr>

                <div class="row">
                    <div class="col-12">
                        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                            class="row-border hover table table-bordered table-sm"></table>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
<ngx-spinner></ngx-spinner>